<template>
<transition name="fade">
 <div class="w-screen h-screen flex justify-center items-center bg-black">
    <img class="absolute inset-0 h-full w-full object-cover opacity-100" src="../assets/WB_back.jpg" alt="" />
    <div class="absolute inset-0 bg-skin-b-back opacity-80"></div>

  <div class="p-6 w-[22rem] bg-skin-b-list-back rounded-xl drop-shadow-lg space-y-5"  ref="LogCont">
    <loading-overlay class="rounded-xl" :active="isLoading" :is-full-page="fullPage" :loader="loader" :color="loadercolor" :background-color="loaderbackcolor" />
    <h1 class="text-center text-3xl text-skin-b-list-base font-semibold">{{LoginHead}}</h1>
    <p v-if="serialno" class="text-center text-skin-b-list-base font-semibold">{{ $t('main.serial') }} {{serialno}}</p>
    <div class="grid grid-cols-2 gap-2 text-center text-sm font-semibold">
      <!--Nutzer
      <div>
        <button @click.prevent="submitForm" @click="profile='Nutzer', this.form.user=''" 
            :class="{'bg-skin-active128 cursor-default shadow-inner': profile=='Nutzer',  
                    'bg-skin-active128/60 hover:bg-skin-active128/80 focus:outline-none focus:ring-0 shadow-md': profile!='Nutzer'}" 
                 class="w-24 p-2 rounded text-skin-b-invt transition duration-150 ease-in-out">
                <svg class="mx-auto" fill=currentColor xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path d="M480 575q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42ZM160 896v-94q0-38 19-65t49-41q67-30 128.5-45T480 636q62 0 123 15.5T731 696q31 14 50 41t19 65v94H160Z"/>
                </svg>
            Nutzer
        </button>        
      </div>-->
      <div>
        <button @click.prevent="submitForm" @click="profile='Benutzer', this.form.user='operator', profilelabel=this.t('login.operatorpass')" 
                :class="{'bg-skin-active128 cursor-default shadow-inner': profile=='Benutzer',  
                        'bg-skin-active128/60 hover:bg-skin-active128/80 focus:outline-none focus:ring-0 shadow-md': profile!='Benutzer'}"
                 class="w-full p-2 rounded text-skin-b-invt transition duration-150 ease-in-out">                       
                <svg class="mx-auto" fill=currentColor xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path d="m667 936-10-66q-17-5-34.5-14.5T593 834l-55 12-25-42 47-44q-2-9-2-25t2-25l-47-44 25-42 55 12q12-12 29.5-21.5T657 600l10-66h54l10 66q17 5 34.5 14.5T795 636l55-12 25 42-47 44q2 9 2 25t-2 25l47 44-25 42-55-12q-12 12-29.5 21.5T731 870l-10 66h-54ZM80 892v-94q0-35 17.5-63t50.5-43q72-32 133.5-46T400 632h23q-21 51-19 134.5T438 892H80Zm614-77q36 0 58-22t22-58q0-36-22-58t-58-22q-36 0-58 22t-22 58q0 36 22 58t58 22ZM400 571q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42Z"/>
                </svg>                
                {{ $t("login.operator") }}
        </button>        
      </div>
      <div>
        <button @click.prevent="submitForm" @click="profile='Installateur', this.form.user='admin', profilelabel=this.t('login.technicianpass')"
               :class="{'bg-skin-active128 cursor-default shadow-inner': profile=='Installateur',  
                        'bg-skin-active128/60 hover:bg-skin-active128/80 focus:outline-none focus:ring-0 shadow-md': profile!='Installateur'}"
                 class="w-full p-2 rounded text-skin-b-invt transition duration-150 ease-in-out"> 
                <svg class="mx-auto" fill=currentColor xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path d="M140 976q-24 0-42-18t-18-42V436q0-24 18-42t42-18h237V236q0-24 18-42t42-18h87q24 0 42 18t18 42v140h236q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm92-167h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5T265 744q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q23 0 38.5-15.5T408 638q0-23-15.5-38.5T354 584q-23 0-38.5 15.5T300 638q0 23 15.5 38.5T354 692Zm214-63h170v-50H568v50ZM437 436h87V236h-87v200Z"/>
                </svg>
                {{ $t("login.technician") }}
        </button>        
      </div>
    </div>
    <form autocomplete="on">
    <div v-if="profile=='Nutzer'" class="flex flex-col space-y-2" :class="{ error: v$.form.user.$errors.length }">
      <label class="font-medium text-sm text-skin-b-list-mute" for="user">Nutzername</label>
        <input class="w-full px-3 py-2 rounded border-2 border-skin-b-list-bord hover:bg-skin-b-list-head focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0" 
        type="text" placeholder="Dein Nutzername" name="user" id="user" ref="user" autocomplete="on" v-model="v$.form.user.$model">
    </div>
    <div class="text-sm font-semibold text-center text-red-800" v-for="(error, index) of v$.form.user.$errors" :key="index">
      <div class="error-msg">{{ error.$message }}</div>
    </div>


    <div class="flex flex-col space-y-2 mt-4" :class="{ error: v$.form.logpass.$errors.length }">
        <label class="font-medium text-sm text-skin-b-list-mute" for="logpass">{{profilelabel}}</label>
        
        <div class="flex flex-row">
          <div class="w-full">
            <input class="w-full px-3 py-2 rounded-l border-2 border-skin-b-list-bord hover:bg-skin-b-list-head focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0" 
            :type="showPassword ? 'text' : 'password'" :placeholder="$t('login.yourpassword')" name="logpass" id="logpass" ref="logpass" autocomplete="on" v-model="v$.form.logpass.$model">        
          </div>
          <div class="">
            <button type="button" @click.prevent="submitForm" :disabled="!v$.form.logpass.$model" class="px-3 py-2 rounded-r border-r-2 border-y-2 disabled:text-skin-b-list-mute border-skin-b-list-bord hover:bg-skin-b-list-head focus:ring-transparent focus:outline-none focus:ring-0" @click="toggleShow">
              <svg v-if="showPassword" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="currentColor">
                <path d="M480.118-330Q551-330 600.5-379.618q49.5-49.617 49.5-120.5Q650-571 600.382-620.5q-49.617-49.5-120.5-49.5Q409-670 359.5-620.382q-49.5 49.617-49.5 120.5Q310-429 359.618-379.5q49.617 49.5 120.5 49.5Zm-.353-58Q433-388 400.5-420.735q-32.5-32.736-32.5-79.5Q368-547 400.735-579.5q32.736-32.5 79.5-32.5Q527-612 559.5-579.265q32.5 32.736 32.5 79.5Q592-453 559.265-420.5q-32.736 32.5-79.5 32.5ZM480-200q-146 0-264-83T40-500q58-134 176-217t264-83q146 0 264 83t176 217q-58 134-176 217t-264 83Z"/>
              </svg>
              <svg v-if="!showPassword" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="currentColor">
                <path d="M816-64 648-229q-35 14-79 21.5t-89 7.5q-146 0-265-81.5T40-500q20-52 55.5-101.5T182-696L56-822l42-43 757 757-39 44ZM480-330q14 0 30-2.5t27-7.5L320-557q-5 12-7.5 27t-2.5 30q0 72 50 121t120 49Zm278 40L629-419q10-16 15.5-37.5T650-500q0-71-49.5-120.5T480-670q-22 0-43 5t-38 16L289-760q35-16 89.5-28T485-800q143 0 261.5 81.5T920-500q-26 64-67 117t-95 93ZM585-463 443-605q29-11 60-4.5t54 28.5q23 23 32 51.5t-4 66.5Z"/>
              </svg>
            </button>
          </div>
        </div>
    </div>
    <div class="text-sm font-semibold text-center text-red-800" v-for="(error, index) of v$.form.logpass.$errors" :key="index">
      <div class="error-msg">{{ error.$message }}</div>
    </div>

    <div class="mt-1 text-right">
        <div class="inline-flex items-center">
            <label class="relative flex items-center p-3 rounded-full cursor-pointer" htmlFor="check">
                <input type="checkbox" v-model="savepassword"
                class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md 
                border-2 border-skin-b-list-bord transition-all 
                before:absolute before:top-2/4 before:left-2/4 before:block before:h-10 before:w-10 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full 
                before:bg-skin-active128 before:opacity-0 before:transition-opacity 
                checked:border-pelo-500 checked:bg-skin-active128 checked:before:bg-skin-active128 hover:before:opacity-10 
                focus:ring-0 focus:checked:bg-skin-active128"
                id="check" />
                <span
                class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"
                    stroke="currentColor" stroke-width="1">
                    <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                </span>
            </label>
            <label class="text-skin-b-list-base cursor-pointer select-none" htmlFor="check">
                {{ $t('login.savepassword') }}
            </label>
        </div>
    </div>

    <button @click.prevent="submitForm" :disabled="v$.form.$invalid" @click="flogin()" class="w-full px-10 py-2 mt-4
            bg-skin-active128
            text-skin-inverted
            font-semibold
            rounded
            shadow-md
            disabled:opacity-50 disabled:hover:bg-skin-active128
            hover:bg-skin-active128 hover:shadow-md
            focus:bg-skin-active128 focus:shadow-md focus:outline-none focus:ring-0
            active:bg-skin-active128 active:shadow-md
            transition duration-300 ease-in-out">
        {{LogBtnText}}
    </button>
    </form>
  </div>
  </div>
</transition>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { useI18n } from 'vue-i18n'
import Cookies from 'js-cookie'

export function validName(name) {
  let validNamePattern = new RegExp("^[a-zA-Z0-9öüäÖÜÄß]+(?:[-'\\S][a-zA-Z0-9]+)*$");
  if (validNamePattern.test(name)){
    return true;
  }
  return false;
}

export default {
  name: 'StartPage',
  setup () {
    const { t } = useI18n() // use as global scope
    return { v$: useVuelidate(), t }
  },
  data() {
    return {
      serialno: '',
      form: {
        user: 'operator',
        logpass: Cookies.get('eo_password') || ''
      },
      showPassword: false,
      savepassword: true,
      utcdate: '',
      profile: 'Benutzer',
      LoginHead: this.t('login.login'),
      LogBtnText: this.t('login.login'),
      profilelabel: this.t('login.operatorpass'),
      isLoading: false,
      fullPage: false,
      loader: "spinner",
      loadercolor: 'rgb(var(--color-active-hsl-128))',
      loaderbackcolor: 'rgb(var(--color-b-back))',
    }
  },
  validations() {
    return {
      form: {
        user: { 
          required: helpers.withMessage('', required),
           name_validation: {   $validator: validName,  $message: 'Nur Buchstaben und Zahlen sind erlaubt!' } 
        },
        logpass: { required: helpers.withMessage('', required),
        // min: minLength(4) 
        }
      },
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    flogin: function() {
        this.isLoading = true;
        this.LogBtnText = this.t('login.loginwait');

        this.axios
        .get('wallbox/login.php?action=login&account='+this.form.user+'&pass='+encodeURIComponent(this.form.logpass))
        .then((response) => {
          if(response.data.login.status=='ok'){
            this.$store.commit('setUser', this.form.user);        
            this.$store.commit('setToken', response.data.login.token);
            if(this.savepassword){
              Cookies.set('eo_password', this.form.logpass, { expires: 3650 });
            }else{
              Cookies.remove('eo_password'); 
            }
            if(this.profile=='Nutzer')
              this.$store.commit('setRole', 'user');
            if(this.profile=='Benutzer')
              this.$store.commit('setRole', 'operator');
            if(this.profile=='Installateur')
              this.$store.commit('setRole', 'admin');
            if(this.profile=='Hersteller')
              this.$store.commit('setRole', 'supplier');

            this.axios
            .get('wallbox/client.php?action=update_clients_async&user='+this.$store.state.token)
            .then((responseclients_list) => {         
                        if(responseclients_list.data.status=='ok'){

                          let refresh_pairingsUrl = 'wallbox/pairing.php?action=refresh_pairings_async&user='+this.$store.state.token;              
                          let client_infoUrl = 'wallbox/client.php?action=client_info&user='+this.$store.state.token;         
                          let search_updateUrl = 'wallbox/update.php?action=search_update_online_async&user='+this.$store.state.token;         
                          const requestrefresh_pairings = this.axios.get(refresh_pairingsUrl);
                          const requestclient_info = this.axios.get(client_infoUrl);
                          const requestsearch_update = this.axios.get(search_updateUrl);
                          this.axios
                          .all([requestrefresh_pairings, requestclient_info,  requestsearch_update])
                          .then(
                              this.axios.spread((...responses) => {                    
                                  const responserefresh_pairings = responses[0];                    
                                  const responseclient_info = responses[1];                    
                                  const responsesearch_update = responses[2];
                                  
                                  if(responserefresh_pairings.data.status=='ok'||responserefresh_pairings.data.status=='network'){//status: network??

                                    if(responseclient_info.data.status=='ok'){
                                      this.$store.commit('setWbName', this.decodeHtml(responseclient_info.data.tbl_clientsettings.name));
                                      this.$store.commit('setWbLogName', this.decodeHtml(responseclient_info.data.tbl_clientsettings.name));
                                      this.$store.commit('setWbLogHost', responseclient_info.data.tbl_clientsettings.hostname);
                                      this.$store.commit('setWbLogSerial', responseclient_info.data.tbl_clientsettings.serial);
                                      this.$store.commit('setWbLogIp', responseclient_info.data.tbl_clientsettings.ip);
                                      this.$store.commit('setWbIp', responseclient_info.data.tbl_clientsettings.ip);
                                      this.$store.commit('setWbTyp', responseclient_info.data.tbl_clientsettings.article);

                                      if(responsesearch_update.data.status=='ok'||responsesearch_update.data.status=='network'){
                                        
                                        if(responsesearch_update.data.tbl_version!=''){
                                          this.$store.commit('setWbSwVersion', responsesearch_update.data.tbl_version.linuxVersion );
                                          this.$store.commit('setWbApiVersion', Number(responsesearch_update.data.tbl_version.apiVersion));
                                          if(responsesearch_update.data.tbl_version.apiVersion>=2)
                                            this.$store.commit('setWbRemoteSettings', true );
                                          else
                                            this.$store.commit('setWbRemoteSettings', false );
                                          
                                          if(responsesearch_update.data.tbl_version.linuxVersion!=''&&responsesearch_update.data.tbl_version.otiVersion!=''&&(responsesearch_update.data.tbl_version.linuxVersion!=responsesearch_update.data.tbl_version.otiVersion)){
                                            this.$store.commit('setNewSW', true );
                                            this.$store.commit('setWbOtiVersion', responsesearch_update.data.tbl_version.otiVersion );
                                            this.$store.commit('setWbOtiInfo', responsesearch_update.data.tbl_version.otiInfo );                              
                                          }
                                          else{
                                            this.$store.commit('setNewSW', false ); 
                                            this.$store.commit('setWbOtiInfo', responsesearch_update.data.tbl_version.otiInfo );                                
                                          }             
                                        }else{
                                          this.$store.commit('setNewSW', false ); 
                                        }
                                        this.synctime();
                                        
                                        if(responseclients_list.data.tbl_clients!=''){ //&&responseclients_list.data.tbl_clients.length>1
                                          this.$store.commit('setFirstLoad', true );
                                          this.$store.commit('setMesh', false );
                                          this.$store.commit('setWbId', -1 );
                                          this.$store.commit('setWbLogId', -1 );
                                          this.isLoading = false;
                                          this.$router.push({path: '/Main'});
                                        }
                                      }else{
                                        console.log('Error get search update Operator Admin Login');                   
                                      }
                                    }else{
                                        console.log('Error get client_info Operator Admin Login');                   
                                    }
                                  }else{
                                      console.log('Error get refresh_pairings Operator Admin Login');                   
                                  }

                              })
                          )
                          .catch((errors) => { //multiabfrage
                              console.error(errors);
                          });



                        }else{
                          console.log('Error Update Clients Operator Admin Login');                   
                        }
                      })
            .catch((errors) => { //client.php?action=update_clients
              console.log(errors); 
            }); 
   


          }else{ //Login status not ok
            if(this.savepassword){
              Cookies.set('eo_password', this.form.logpass, { expires: 3650 });
            }else{
              Cookies.remove('eo_password'); 
            }
            this.isLoading = false;
            if(response.data.login.status=='locked')
              this.LoginHead = this.t('login.loginlocked');
            else
              this.LoginHead = this.t('login.loginfailed');
            this.LogBtnText = this.t('login.login');
            console.log('Error login');
          }

        })
        .catch((errors) => { //login.php?action=login
                  console.log(errors);
        });

    },
    synctime() {
      let tzOffset = (new Date).getTimezoneOffset();
      this.utcdate = this.$dayjs(this.$dayjs(new Date).add(tzOffset,'minute')).format('YYYY-MM-DD HH:mm:ss');
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.axios
                .get('wallbox/client.php?action=sync_client_time_async&user='+this.$store.state.token+'&time='+this.utcdate+'&timezone='+tz)
                .then((response) => {  
                            if(response.data.status=='ok'){
                              console.log('Gesendet '+this.utcdate);
                            }else{
                              console.log('fehler sync time');                   
                            }
                          })
                .catch((errors) => {
                  console.log(errors); // Errors
                });       
    }
  },
  mounted() {
    // const urlParams = new URLSearchParams(window.location.search);

    // if (urlParams.has('pass')) {
    //   this.form.logpass = urlParams.get('pass');
    //   this.flogin();
    // }    
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('pass')){
      this.form.logpass=urlParams.get('pass');
    }
    this.axios
              .get('wallbox/login.php?action=get_serial')
              .then((response) => {  
                          if(response.data.status=='ok'){
                            this.serialno = response.data.serial;
                          }else{
                            this.serialno = this.t('login.noserial');                   
                          }
                        })
              .catch((errors) => {
                console.log(errors); // Errors
              }); 
  }
}

</script>
<style scoped>
</style>
